export const Itineraries = {
  AREA_LIST: '/areas', // Retorna todas áreas tecnológicas de uma versão
  AREA_ID: 'areas/{areaId}', // Retorna área tecnológica específica
  AREA_ID_VERSIONS: 'areas/{areaId}/versions', // Retorna as versões de uma área tecnológica
  AREA_ID_COURSES: '/courses/areaVersion/{areaVersionId}', // Retorna todos os cursos de uma versão de área tecnológica
  AREA_ID_HISTORY: '/areas/{idArea}/history', // Retorna área tecnológica específica
  AREA_ID_OCCUPATION: '/areas/{idArea}/occupations', // Retorna todas ocupações
  AREA_ID_OCCUPATION_ID: '/areas/{idArea}/occupations/{idOccupation}', // Retorna ocupação específica
  AREA_ID_OCCUPATION_ID_SOCIO_EMOTIONAL_SKILLS:
    '/areas/{idArea}/occupations/{idOccupation}/socio-emotional-skills',
  AREA_ID_OCCUPATION_ID_INTERMEDIATE_OUTPUTS:
    '/areas/{idArea}/occupations/{idOccupation}/intermediate-outputs',
  AREA_ID_OCCUPATION_ID_WORK_CONTEXT_MEANS_OF_PRODUCTION:
    'itineraries/areas/{idArea}/occupations/{idOccupation}/work-context/means-of-production', // Retorna meios de produção da ocupação
  AREA_ID_OCCUPATION_ID_WORK_CONTEXT_PROFESSIONS:
    '/areas/{idArea}/occupations/{idOccupation}/work-context/related-profession', // Retorna lista de profissões relacionadas de uma ocupação específica
  AREA_ID_OCCUPATION_ID_WORK_CONTEXT_EVOLUTIONS:
    '/areas/{idArea}/occupations/{idOccupation}/work-context/evolution', // Retorna lista de evoluções de uma ocupação específica
  AREA_ID_OCCUPATION_ID_WORK_CONTEXT_WORKING_CONDITION:
    '/areas/{idArea}/occupations/{idOccupation}/work-context/working-condition',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module', // Retorna lista de módulos de UCs de uma ocupação específica
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}', // Retorna unidade curricular específica
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_FUNCTIONS:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/functions',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_ACQUIREMENTS:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/acquirements',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_BASIC_CAPABILITIES:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/basic-capabilities',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_TECHNICAL_CAPABILITIES:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/technical-capabilities',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_RELATED_OCCUPATIONS:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/related-occupations',
  AREA_ID_OCCUPATION_ID_CURRICULAR_ORGANIZATION_MODULE_CURRICULAR_UNIT_ID_ENVIRONMENTS:
    '/areas/{idArea}/occupations/{idOccupation}/curricular-organization/module/curricular-unit/{idCurricularUnit}/pedagogical-environments', // Retorna lista de ambientes pedagógicos de uma UC específica
  AREA_ID_PROFESSIONAL_INITIATION: '/areas/{idArea}/professional-initiations',
  AREA_ID_PROFESSIONAL_INITIATION_ID:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}',
  AREA_ID_PROFESSIONAL_INITIATION_FUNCTIONS:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}/functions',
  AREA_ID_PROFESSIONAL_INITIATION_BASIC_CAPABILITIES:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}/basic-capabilities',
  AREA_ID_PROFESSIONAL_INITIATION_ACQUIREMENTS:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}/acquirements',
  AREA_ID_PROFESSIONAL_INITIATION_TECHNICAL_CAPABILITIES:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}/technical-capabilities',
  AREA_ID_PROFESSIONAL_INITIATION_RELATED_OCCUPATIONS:
    '/areas/{idArea}/professional-initiations/{idProfessionalInitiation}/related-occupations',
  AREA_ID_IMPROVEMENT: '/areas/{idArea}/improvements',
  AREA_ID_IMPROVEMENT_ID: '/areas/{idArea}/improvements/{idImprovement}',
  AREA_ID_IMPROVEMENT_FUNCTIONS:
    '/areas/{idArea}/improvements/{idImprovement}/functions',
  AREA_ID_IMPROVEMENT_BASIC_CAPABILITIES:
    '/areas/{idArea}/improvements/{idImprovement}/basic-capabilities',
  AREA_ID_IMPROVEMENT_ACQUIREMENTS:
    '/areas/{idArea}/improvements/{idImprovement}/acquirements',
  AREA_ID_IMPROVEMENT_TECHNICAL_CAPABILITIES:
    '/areas/{idArea}/improvements/{idImprovement}/technical-capabilities',
  AREA_ID_IMPROVEMENT_RELATED_OCCUPATIONS:
    '/areas/{idArea}/improvements/{idImprovement}/related-occupations',
  AREAS_VERSIONS: '/versions',
  AREAS_FUNCTIONS_COURSE_VERSION_ID:
    '/functions/course-version/{courseVersionId}',
  AREAS_FUNCTIONS_COURSE_VERSION_ID_COMMITTEE_ID:
    '/functions/course-version/{courseVersionId}?committeeId={committeeId}',
  AREAS_SUBFUNCTIONS_FUNCTION_ID_COURSE_VERSION_ID:
    '/subfunctions/functions/{functionId}/course-version/{courseVersionId}',
  AREAS_SUBFUNCTION_DETAILS_FUNCTION_ID_SUBFUNCTION_ID_COURSE_VERSION_ID:
    '/subfunctions/{subfunctionId}/details/function/{functionId}/course-version/{courseVersionId}',
  AREAS_FUNCTIONS_DETAILS_COURSE_VERSION_ID:
    '/functions/details/course-version/{courseVersionId}',
  AREAS_WORK_CONTEXT_COURSE_VERSION_ID_EVOLUTIONS:
    '/work-context/course-version/{courseVersionId}/evolutions',
  AREAS_WORK_CONTEXT_COURSE_VERSION_ID_PRODUCTION_MEANS:
    '/work-context/course-version/{courseVersionId}/production-means',
  AREAS_WORK_CONTEXT_COURSE_VERSION_ID_PROFESSIONAL_FORMATIONS:
    '/work-context/course-version/{courseVersionId}/professional-formations',
  AREAS_MODULES_COURSE_VERSION_ID:
    '/module-list/course-version/{courseVersionId}',
  AREAS_CURRICULAR_UNIT_MODULES_COURSE_VERSION_ID:
    '/curricular-unit-list/module-course-version/{moduleCourseVersionId}',
  AREAS_WORK_CONTEXT_COURSE_VERSION_ID_WORK_CONDITION:
    '/work-context/course-version/{courseVersionId}/work-condition',
  AREAS_MODULES_DETAILS_COURSE_VERSION_ID:
    '/module-list/details/course-version/{courseVersionId}',
  AREAS_INTERMEDIATE_EXITS_COURSE_VERSION_ID:
    '/course-version/{courseVersionId}/intermediate-exit-list',
  AREAS_INTERMEDIATE_EXITS_EXIST_COURSE_VERSION_ID:
    '/course-version/{courseVersionId}/intermediate-exit-list/exists',
  AREAS_INFRASTRUCTURE_CURRICULAR_UNIT_COURSE_VERSION_ID:
    '/infrastructure-list/curricular-unit-course-version/{curricularUnitCourseVersionId}',
  AREAS_UTILIZATION_COURSE_VERSION_ID:
    '/utilization-list/course-version/{courseVersionId}',
  AREAS_KNOWLEDGE_CURRICULAR_UNIT_COURSE_VERSION_ID:
    '/knowledge/curricular-unit-course-version/{curricularUnitCourseVersionId}',
  AREAS_CNAE_COURSE_ID: 'cnae-list/course-version/${courseVersionId}',
  AREAS_CNAE_AREA_VERSION_ID: 'cnae-list/area-version/${areaVersionId}',
  AREAS_CAPACITIES_BASIC_CURRICULAR_UNIT_COURSE_VERSION_ID:
    '/capacities/basic/curricular-unit-course-version/{curricularUnitCourseVersionId}',
  AREAS_CAPACITIES_TECHNICAL_CURRICULAR_UNIT_COURSE_VERSION_ID:
    '/capacities/technical/curricular-unit-course-version/{curricularUnitCourseVersionId}',
  AREAS_CAPACITIES_COURSE_VERSION_ID:
    'capacities/course-without-profile/course-version/{courseVersionId}',
  AREAS_COMMITTEE_PARTICIPANTS_COURSE_VERSION_ID:
    'committee-list/course-version/{courseVersionId}/participants',
  AREAS_SOCIOEMOTIONAL_COMPETENCE_COURSE_VERSION_ID:
    'socioemotional-competence/course-version/{courseVersionId}',

  COURSE_VERSION_ID: 'courses/{courseVersionId}', // Retorna curso específica
} as const
